import { env } from '@/config/env';

/**
 * URL of the Zuora HPM 2.0 client library. Zuora ships a single CDN-hosted,
 * version-pinned bundle for all tenants — this mirrors the Frontend repo's
 * `partner/email-payment` integration (`pages/_document.tsx`).
 *
 * Bump cautiously: changes to the JS lib can break our `Z.*` call sites.
 */
export const ZUORA_HPP_SCRIPT_URL =
  'https://static.zuora.com/Resources/libs/hosted/1.3.1/zuora-min.js';

/** Hosted Payment Page submit URL — used as the `url` param of `Z.render`. */
export const ZUORA_HPP_SUBMIT_URL = env.NEXT_PUBLIC_ZUORA_HPP_URL;
